/**
 * @fileoverview DotIcon component - a simple circular dot for status indicators
 * @example
 * import { DotIcon } from "@credcore/core-ui/icons";
 * <DotIcon className="bg-red-500" />
 */

import { forwardRef } from "react";
import { cn } from "../utils/cn";

export type DotIconProps = {
  className?: string;
  "data-testid"?: string;
};

/**
 * A simple dot/circle icon component for status indicators.
 *
 * @example
 * <DotIcon className="bg-red-500" />
 * <DotIcon className="h-3 w-3 bg-yellow-600" />
 */
export const DotIcon = forwardRef<HTMLSpanElement, DotIconProps>(
  ({ className, "data-testid": dataTestId, ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn("inline-block h-2 w-2 rounded-full", className)}
        data-testid={dataTestId ?? "dot-icon"}
        {...props}
      />
    );
  },
);
DotIcon.displayName = "DotIcon";
